import React, { useState } from 'react';
import DealList from '../components/deals/DealList';
import { useLanguage } from '../contexts/LanguageContext';
import CommonPageHeader from '../components/common/CommonPageHeader';
import { BriefcaseIcon, PlusIcon } from '@heroicons/react/24/outline';

const Deals = () => {
  const { t } = useLanguage();
  const [shouldOpenForm, setShouldOpenForm] = useState(false);

  const handleNewClick = () => {
    setShouldOpenForm(true);
  };

  const handleFormOpened = () => {
    setShouldOpenForm(false);
  };

  return (
    <div className="space-y-4">
      <CommonPageHeader
        title={t('deals.title')}
        subtitle={t('deals.subtitle') || 'Üzletek és megállapodások kezelése'}
        icon={BriefcaseIcon}
      >
        <button
          onClick={handleNewClick}
          className="bg-white/20 dark:bg-gray-800/20 backdrop-blur-sm text-white px-3 py-2 rounded-md text-sm flex items-center justify-center hover:bg-white/30 dark:hover:bg-gray-800/30 transition-colors"
        >
          <PlusIcon className="h-4 w-4 mr-2" />
          <span>{t('deals.new')}</span>
        </button>
      </CommonPageHeader>

      <DealList 
        triggerNewForm={shouldOpenForm}
        onFormOpened={handleFormOpened}
      />
    </div>
  );
};

export default Deals; 